var normalizeComponent = require("!../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"presets\":[[\"env\",{\"targets\":{\"browsers\":[\">1%\",\"last 4 versions\",\"Firefox ESR\",\"not ie < 9\",\"iOS >= 8\",\"Android >= 4\"]}}],\"stage-2\",\"react\"]}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"
import __vue_script__ from "!!babel-loader?{\"presets\":[[\"env\",{\"targets\":{\"browsers\":[\">1%\",\"last 4 versions\",\"Firefox ESR\",\"not ie < 9\",\"iOS >= 8\",\"Android >= 4\"]}}],\"stage-2\",\"react\"]}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"
/* template */
import __vue_template__ from "!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c01b644c\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./components/App.vue
// module id = 345
// module chunks = 5